import { FC } from 'react'
import cn from 'classnames'

import styles from './Tile.pcss'
import classNames from 'classnames'

interface TileElements {
	Header: FC<{ children: React.ReactNode }>
	Item: FC<{ className?: string; disabled?: boolean; children: React.ReactNode }>
	Footer: FC<{ children: React.ReactNode }>
}

const Tile: FC<{ children: React.ReactNode }> & TileElements = ({ children }) => (
	<div className={styles.tile}>{children}</div>
)

const TileHeader: FC<{ children: React.ReactNode }> = ({ children }) => (
	<header className={styles.header}>{children}</header>
)

const TileItem: FC<{ className?: string; disabled?: boolean; children: React.ReactNode }> = ({
	disabled = false,
	className,
	children,
}) => (
	<div
		className={cn(
			styles.item,
			styles.inner,
			disabled && styles.disabled,
			className
		)}
	>
		{children}
	</div>
)

const TileFooter: FC<{ children: React.ReactNode }> = ({ children }) => (
	<footer className={classNames(styles.footer, styles.item)}>
		{children}
	</footer>
)

Tile.Header = TileHeader
Tile.Item = TileItem
Tile.Footer = TileFooter

export default Tile
